import { getClient } from "./client";
import type { ApiEndMessage } from "./shared";

export const getEndMessage = (gameId: string) =>
  getClient({ authenticate: true })
    .get(`/api/games/${gameId}/end-message`)
    .json<ApiEndMessage | null>();
